export const VALIDATE_DATA_TYPE = 'string';
export const QUOTES_LIST = ['"'];
export const CLOSE_OPEN_BRACKETS_MAP = {
  ')': '(',
};
export const VALIDATION_ID_WHITELIST = { 'RX.TRANS': true };
export const BLACKLISTED_UNICODE_RANGES = [
  // Cyrillic
  '\u0400-\u04FF',
  // Japanese (Hiragana, Katakana)
  '\u3040-\u309F',
  '\u30A0-\u30FF',
  // CJK Unified Ideographs
  '\u4E00-\u9FFF',
  '\u3400-\u4DBF',
];
